import React, {Component, Fragment} from 'react'
import {observer} from 'mobx-react'
import PropTypes from 'prop-types'

import SpanLink from 'lib/control/SpanLink'

import InputText from '../control/DependentInputText'
import Select from '../control/DependentSelect'

import Icon from 'lib/struct/icon/Icon';

import * as UnitMode from '../../constant/OfferCustomParamUnitMode'

import styles from './CustomParamTagSourceField.less'

const {
    'field': field_class,
    'field_with-hint': field_with_hint_class,
    'field-label': label_class,
    'field-box': box_class,
    'field-tag': tag_class,
    'field-tag-arrow': tag_arrow_class,
    'field-tag-label': tag_label_class,
    'value-hint': hint_class,
    'field-main': field_main_class,
    'field-tag-label-before': tag_label_before_class
} = styles

@observer export default class CustomParamTagSourceField extends Component {
    render() {
        /** @type {OfferCustomParam} */
        const custom_param = this.props.custom_param

        const {
            with_unit, label, tag, hint, state,
            labelClass, children
        } = this.props

        const field_classes = [field_class]
        if (hint) {
            field_classes.push(field_with_hint_class)
        }

        if (!with_unit && custom_param.unit_mode !== UnitMode.CUSTOM) {
            const p = new Promise(() => {
                const e = {target: {value: UnitMode.CUSTOM}}
                this.onUnitModeChange(e)
            })
        }
        return (
            <Fragment>
                <div className={field_classes.join(' ')}>
                    <div className={label_class}>
                        {label}
                    </div>
                    <div className={field_main_class}>
                        <div className={box_class}>{children}</div>
                        <div className={tag_class}>
                            {
                                tag ? (
                                    <Fragment>
                                        <div className={tag_label_class}>
                                            <span className={tag_label_before_class}>
                                                <span className={tag_arrow_class}>→</span>{'<'}{tag} <b>name</b>=
                                            </span>
                                            <InputText
                                                value={custom_param.name}
                                                onChange={this.onNameChange}
                                                state={state}
                                                className={styles['field-tag-tag-input']}
                                            />{'>'}</div>

                                        <div className={tag_label_class}>
                                            <span className={tag_label_before_class}>{'<'}{tag} <b>unit</b>=</span>

                                            {
                                                with_unit ? (
                                                    <Select
                                                        options={UnitMode.control_options}
                                                        value={custom_param.unit_mode}
                                                        onChange={this.onUnitModeChange}
                                                        state={state}
                                                    />
                                                ) : (null)
                                            }

                                            {
                                                custom_param.unit_mode === UnitMode.CUSTOM ? (
                                                    <InputText
                                                        value={custom_param.custom_unit}
                                                        onChange={this.onCustomUnitChange}
                                                        state={state}
                                                        className={styles['field-tag-tag-input']}
                                                    />
                                                ) : (null)
                                            }
                                            {'>'}
                                        </div>


                                    </Fragment>
                                ) : (null)
                            }
                        </div>
                    </div>
                    <div className={styles['field-tag-delete-button-wrapper']}>
                        <SpanLink onClick={this.onParamDelete}><Icon name="delete"/></SpanLink>
                    </div>
                </div>

                {
                    hint ? (
                        <div className={hint_class}>{hint}</div>
                    ) : (null)
                }
            </Fragment>
        )
    }

    onNameChange = (event) => {
        /** @type {OfferCustomParam} */
        const custom_param = this.props.custom_param

        const {onNameChange} = this.props

        onNameChange(custom_param, event.target.value)
    }

    onUnitModeChange = (event) => {
        /** @type {OfferCustomParam} */
        const custom_param = this.props.custom_param

        const {onUnitModeChange} = this.props

        onUnitModeChange(custom_param, event.target.value)
    }

    onCustomUnitChange = (event) => {
        /** @type {OfferCustomParam} */
        const custom_param = this.props.custom_param

        const {onCustomUnitChange} = this.props

        onCustomUnitChange(custom_param, event.target.value)
    }

    onParamDelete = () => {
        /** @type {OfferCustomParam} */
        const custom_param = this.props.custom_param

        const {onParamDelete} = this.props

        onParamDelete(custom_param)
    }
}

CustomParamTagSourceField.propTypes = {
    label: PropTypes.any,
    tag: PropTypes.any,
    with_unit: PropTypes.any,
    custom_param: PropTypes.any,
    state: PropTypes.any,
    onNameChange: PropTypes.any,
    onParamDelete: PropTypes.any,
    onUnitModeChange: PropTypes.any,
    onCustomUnitChange: PropTypes.any
}
